import React from 'react'

import Loading from 'flynk.app.web.core.components/components/Loading'

const QuoteLoading = () => (
  <Loading loadingWrapperClassName="quote-loading-wrapper" />
)

export default QuoteLoading
